import { BaseModel } from '@shared/base.model';

export class ProgramApplicationStatus extends BaseModel<ProgramApplicationStatus> {
  name: string;
  color: string;
  timestamp: Date;
  editableApplication: boolean;
  editableApplicationDocuments: boolean;
  canDeleteApplicationDocuments: boolean;
  canRenameApplicationDocuments: boolean;
  allowProjectProgramConnection: boolean;
  allowAdvanceToNextStage: boolean;
  viewReporting: boolean;

  constructor(programApplicationStatusInfo) {
    super();
    this.name = programApplicationStatusInfo.name;
    this.color = programApplicationStatusInfo.color;
    this.timestamp = programApplicationStatusInfo.timestamp;
    this.editableApplication = programApplicationStatusInfo.editableApplication;
    this.editableApplicationDocuments = programApplicationStatusInfo.editableApplicationDocuments;
    this.canDeleteApplicationDocuments = programApplicationStatusInfo.canDeleteApplicationDocuments;
    this.canRenameApplicationDocuments = programApplicationStatusInfo.canRenameApplicationDocuments;
    this.allowProjectProgramConnection = programApplicationStatusInfo.allowProjectProgramConnection;
    this.allowAdvanceToNextStage = programApplicationStatusInfo.allowAdvanceToNextStage;
    this.viewReporting = programApplicationStatusInfo.viewReporting;
  }
}
